/* eslint-disable */
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** This is useful when we have to return something. */
  Unit: any;
  DateTime: any;
};

export type AcquisitionProfile = {
  __typename?: 'AcquisitionProfile';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  qualifiedTrafficSource?: Maybe<Scalars['String']>;
};

export enum ChangeEmailError {
  EmailExists = 'EMAIL_EXISTS',
  EmailInvalid = 'EMAIL_INVALID',
  Unknown = 'UNKNOWN'
}

export type ChangeEmailFailure = {
  __typename?: 'ChangeEmailFailure';
  error: ChangeEmailError;
};

export type ChangeEmailInput = {
  newEmail: Scalars['String'];
};

export type ChangeEmailResult = ChangeEmailFailure | ChangeEmailSuccess;

export type ChangeEmailSuccess = {
  __typename?: 'ChangeEmailSuccess';
  uid: Scalars['ID'];
};

export enum ConfirmEmailVerificationError {
  ExpiredOobCode = 'EXPIRED_OOB_CODE',
  InvalidOobCode = 'INVALID_OOB_CODE'
}

export type ConfirmEmailVerificationFailure = {
  __typename?: 'ConfirmEmailVerificationFailure';
  error: ConfirmEmailVerificationError;
};

export type ConfirmEmailVerificationInput = {
  oobCode: Scalars['String'];
};

export type ConfirmEmailVerificationResult = ConfirmEmailVerificationFailure | ConfirmEmailVerificationSuccess;

export type ConfirmEmailVerificationSuccess = {
  __typename?: 'ConfirmEmailVerificationSuccess';
  unit?: Maybe<Scalars['Unit']>;
};


export enum LoginWithIdTokenError {
  TokenExpired = 'TOKEN_EXPIRED',
  TokenInvalid = 'TOKEN_INVALID',
  TokenRevoked = 'TOKEN_REVOKED',
  Unknown = 'UNKNOWN'
}

export type LoginWithIdTokenFailure = {
  __typename?: 'LoginWithIdTokenFailure';
  error: LoginWithIdTokenError;
};

export type LoginWithIdTokenResult = LoginWithIdTokenFailure | LoginWithIdTokenSuccess;

export type LoginWithIdTokenSuccess = {
  __typename?: 'LoginWithIdTokenSuccess';
  uid: Scalars['ID'];
};

export enum LoginWithPasswordError {
  IncorrectCredentials = 'INCORRECT_CREDENTIALS',
  TooManyAttemptsTryLater = 'TOO_MANY_ATTEMPTS_TRY_LATER',
  Unknown = 'UNKNOWN',
  UserDisabled = 'USER_DISABLED'
}

export type LoginWithPasswordFailure = {
  __typename?: 'LoginWithPasswordFailure';
  error: LoginWithPasswordError;
};

export type LoginWithPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginWithPasswordResult = LoginWithPasswordFailure | LoginWithPasswordSuccess;

export type LoginWithPasswordSuccess = {
  __typename?: 'LoginWithPasswordSuccess';
  customToken: Scalars['String'];
};

export enum LoginWithRefreshTokenError {
  InvalidRefreshToken = 'INVALID_REFRESH_TOKEN',
  TokenExpired = 'TOKEN_EXPIRED',
  Unknown = 'UNKNOWN',
  UserDisabled = 'USER_DISABLED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type LoginWithRefreshTokenFailure = {
  __typename?: 'LoginWithRefreshTokenFailure';
  error: LoginWithRefreshTokenError;
};

export type LoginWithRefreshTokenResult = LoginWithRefreshTokenFailure | LoginWithRefreshTokenSuccess;

export type LoginWithRefreshTokenSuccess = {
  __typename?: 'LoginWithRefreshTokenSuccess';
  uid: Scalars['ID'];
};

/** LogoutResult doesn't provide meaningful value, but to return something. */
export enum LogoutResult {
  Succeeded = 'Succeeded'
}

export type Me = {
  __typename?: 'Me';
  account?: Maybe<UserAccount>;
  acquisitionProfile?: Maybe<AcquisitionProfile>;
  profile?: Maybe<UserProfile>;
};

export type MedicalSchool = {
  __typename?: 'MedicalSchool';
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  changeEmail: ChangeEmailResult;
  confirmEmailVerification: ConfirmEmailVerificationResult;
  loginWithIdToken: LoginWithIdTokenResult;
  loginWithPassword: LoginWithPasswordResult;
  loginWithRefreshToken: LoginWithRefreshTokenResult;
  logout: LogoutResult;
  recoverEmail: RecoverEmailResult;
  registerAcquisitionUser: RegisterAcquisitionUserResult;
  registerQualifiedTrafficUser: RegisterQualifiedTrafficUserResult;
  registerUser: RegisterUserResult;
  resetPassword: ResetPasswordResult;
  sendEmailVerification: SendEmailVerificationResult;
  setAcquisitionParams: SetAcquisitionParamsResult;
  updateUserProfile: UpdateUserProfileResult;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationConfirmEmailVerificationArgs = {
  input: ConfirmEmailVerificationInput;
};


export type MutationLoginWithIdTokenArgs = {
  idToken: Scalars['String'];
};


export type MutationLoginWithPasswordArgs = {
  input: LoginWithPasswordInput;
};


export type MutationLoginWithRefreshTokenArgs = {
  refreshToken: Scalars['String'];
  registrationTrackingData?: Maybe<RegistrationTrackingData>;
};


export type MutationRecoverEmailArgs = {
  input: RecoverEmailInput;
};


export type MutationRegisterAcquisitionUserArgs = {
  input: RegisterAcquisitionUserInput;
  registrationTrackingData?: Maybe<RegistrationTrackingData>;
};


export type MutationRegisterQualifiedTrafficUserArgs = {
  input: RegisterQualifiedTrafficUserInput;
  registrationTrackingData?: Maybe<RegistrationTrackingData>;
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
  registrationTrackingData?: Maybe<RegistrationTrackingData>;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSetAcquisitionParamsArgs = {
  input: SetAcquisitionParamsInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};

export type Profession = {
  __typename?: 'Profession';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PublicSchema = {
  __typename?: 'PublicSchema';
  mutation: Array<Scalars['String']>;
  query: Array<Scalars['String']>;
  subscription: Array<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  me: Me;
  professions: Array<Profession>;
  publicSchema: PublicSchema;
  searchMedicalSchools: SearchMedicalSchoolsResult;
};


export type QuerySearchMedicalSchoolsArgs = {
  input: SearchMedicalSchoolsInput;
};

export enum RecoverEmailError {
  ExpiredOobCode = 'EXPIRED_OOB_CODE',
  InvalidOobCode = 'INVALID_OOB_CODE',
  Unknown = 'UNKNOWN'
}

export type RecoverEmailFailure = {
  __typename?: 'RecoverEmailFailure';
  error: RecoverEmailError;
};

export type RecoverEmailInput = {
  oobCode: Scalars['String'];
};

export type RecoverEmailResult = RecoverEmailFailure | RecoverEmailSuccess;

export type RecoverEmailSuccess = {
  __typename?: 'RecoverEmailSuccess';
  uid: Scalars['ID'];
};

export enum RegisterAcquisitionUserError {
  AcquisitionParamsNotFound = 'ACQUISITION_PARAMS_NOT_FOUND',
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  EmailInvalid = 'EMAIL_INVALID'
}

export type RegisterAcquisitionUserFailure = {
  __typename?: 'RegisterAcquisitionUserFailure';
  error: RegisterAcquisitionUserError;
};

export type RegisterAcquisitionUserInput = {
  email: Scalars['String'];
};

export type RegisterAcquisitionUserResult = RegisterAcquisitionUserFailure | RegisterAcquisitionUserSuccess;

export type RegisterAcquisitionUserSuccess = {
  __typename?: 'RegisterAcquisitionUserSuccess';
  uid: Scalars['ID'];
};

export enum RegisterQualifiedTrafficUserError {
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  EmailInvalid = 'EMAIL_INVALID',
  QualifiedTrafficSourceNotFound = 'QUALIFIED_TRAFFIC_SOURCE_NOT_FOUND'
}

export type RegisterQualifiedTrafficUserFailure = {
  __typename?: 'RegisterQualifiedTrafficUserFailure';
  error: RegisterQualifiedTrafficUserError;
};

export type RegisterQualifiedTrafficUserInput = {
  email: Scalars['String'];
};

export type RegisterQualifiedTrafficUserResult = RegisterQualifiedTrafficUserFailure | RegisterQualifiedTrafficUserSuccess;

export type RegisterQualifiedTrafficUserSuccess = {
  __typename?: 'RegisterQualifiedTrafficUserSuccess';
  uid: Scalars['ID'];
};

export enum RegisterUserError {
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  EmailInvalid = 'EMAIL_INVALID',
  PostalCodeRequired = 'POSTAL_CODE_REQUIRED'
}

export type RegisterUserFailure = {
  __typename?: 'RegisterUserFailure';
  error: RegisterUserError;
};

export type RegisterUserInput = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  selfReportedUsmd?: Maybe<Scalars['Boolean']>;
};

export type RegisterUserResult = RegisterUserFailure | RegisterUserSuccess;

export type RegisterUserSuccess = {
  __typename?: 'RegisterUserSuccess';
  uid: Scalars['ID'];
  userCanBeVerified: Scalars['Boolean'];
};

export type RegistrationTrackingData = {
  pageUrl: Scalars['String'];
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
};

export enum ResetPasswordError {
  ExpiredOobCode = 'EXPIRED_OOB_CODE',
  InvalidOobCode = 'INVALID_OOB_CODE',
  Unknown = 'UNKNOWN',
  WeakPassword = 'WEAK_PASSWORD'
}

export type ResetPasswordFailure = {
  __typename?: 'ResetPasswordFailure';
  error: ResetPasswordError;
  message?: Maybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  newPassword: Scalars['String'];
  oobCode: Scalars['String'];
};

export type ResetPasswordResult = ResetPasswordFailure | ResetPasswordSuccess;

export type ResetPasswordSuccess = {
  __typename?: 'ResetPasswordSuccess';
  uid: Scalars['ID'];
};

export enum SearchMedicalSchoolsError {
  ApiRequestFailed = 'API_REQUEST_FAILED',
  NameSearchTermLengthLessThanFive = 'NAME_SEARCH_TERM_LENGTH_LESS_THAN_FIVE',
  Unknown = 'UNKNOWN'
}

export type SearchMedicalSchoolsFailure = {
  __typename?: 'SearchMedicalSchoolsFailure';
  error: SearchMedicalSchoolsError;
};

export type SearchMedicalSchoolsInput = {
  nameSearchTerm: Scalars['String'];
};

export type SearchMedicalSchoolsResult = SearchMedicalSchoolsFailure | SearchMedicalSchoolsSuccess;

export type SearchMedicalSchoolsSuccess = {
  __typename?: 'SearchMedicalSchoolsSuccess';
  medicalSchools: Array<MedicalSchool>;
};

export enum SendEmailVerificationError {
  LoginRequired = 'LOGIN_REQUIRED'
}

export type SendEmailVerificationFailure = {
  __typename?: 'SendEmailVerificationFailure';
  error: SendEmailVerificationError;
};

export type SendEmailVerificationResult = SendEmailVerificationFailure | SendEmailVerificationSuccess;

export type SendEmailVerificationSuccess = {
  __typename?: 'SendEmailVerificationSuccess';
  unit?: Maybe<Scalars['Unit']>;
};

export enum SetAcquisitionParamsError {
  LoggedInUser = 'LOGGED_IN_USER',
  MissingVendorId = 'MISSING_VENDOR_ID',
  MissingVendorUserId = 'MISSING_VENDOR_USER_ID',
  SessionNotFound = 'SESSION_NOT_FOUND'
}

export type SetAcquisitionParamsFailure = {
  __typename?: 'SetAcquisitionParamsFailure';
  error: SetAcquisitionParamsError;
};

export type SetAcquisitionParamsInput = {
  qualifiedTrafficSource?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['Int']>;
  vendorUserId?: Maybe<Scalars['String']>;
};

export type SetAcquisitionParamsResult = SetAcquisitionParamsFailure | SetAcquisitionParamsSuccess;

export type SetAcquisitionParamsSuccess = {
  __typename?: 'SetAcquisitionParamsSuccess';
  success?: Maybe<Scalars['Boolean']>;
};


export type UpdateUserProfileInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  medicalSchool?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['Int']>;
  selfReportedUsmd?: Maybe<Scalars['Boolean']>;
  specialtyId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

export type UpdateUserProfileResult = {
  __typename?: 'UpdateUserProfileResult';
  uid: Scalars['ID'];
  verifiedUsmd: Scalars['Boolean'];
};

export type UserAccount = {
  __typename?: 'UserAccount';
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  uid: Scalars['String'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  country?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  medicalSchool?: Maybe<Scalars['String']>;
  profession?: Maybe<Profession>;
  selfReportedUsmd: Scalars['Boolean'];
  specialtyId?: Maybe<Scalars['Int']>;
  specialtyName?: Maybe<Scalars['String']>;
};

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailInput;
}>;


export type ChangeEmailMutation = (
  { __typename?: 'Mutation' }
  & { changeEmail: (
    { __typename?: 'ChangeEmailFailure' }
    & Pick<ChangeEmailFailure, 'error'>
  ) | (
    { __typename?: 'ChangeEmailSuccess' }
    & Pick<ChangeEmailSuccess, 'uid'>
  ) }
);

export type ConfirmEmailVerificationMutationVariables = Exact<{
  input: ConfirmEmailVerificationInput;
}>;


export type ConfirmEmailVerificationMutation = (
  { __typename?: 'Mutation' }
  & { confirmEmailVerification: (
    { __typename?: 'ConfirmEmailVerificationFailure' }
    & Pick<ConfirmEmailVerificationFailure, 'error'>
  ) | (
    { __typename?: 'ConfirmEmailVerificationSuccess' }
    & Pick<ConfirmEmailVerificationSuccess, 'unit'>
  ) }
);

export type LoginWithIdTokenMutationVariables = Exact<{
  idToken: Scalars['String'];
}>;


export type LoginWithIdTokenMutation = (
  { __typename?: 'Mutation' }
  & { loginWithIdToken: (
    { __typename: 'LoginWithIdTokenFailure' }
    & Pick<LoginWithIdTokenFailure, 'error'>
  ) | (
    { __typename: 'LoginWithIdTokenSuccess' }
    & Pick<LoginWithIdTokenSuccess, 'uid'>
  ) }
);

export type LoginWithPasswordMutationVariables = Exact<{
  input: LoginWithPasswordInput;
}>;


export type LoginWithPasswordMutation = (
  { __typename?: 'Mutation' }
  & { loginWithPassword: (
    { __typename: 'LoginWithPasswordFailure' }
    & Pick<LoginWithPasswordFailure, 'error'>
  ) | (
    { __typename: 'LoginWithPasswordSuccess' }
    & Pick<LoginWithPasswordSuccess, 'customToken'>
  ) }
);

export type LoginWithRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
  registrationTrackingData: RegistrationTrackingData;
}>;


export type LoginWithRefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { loginWithRefreshToken: (
    { __typename: 'LoginWithRefreshTokenFailure' }
    & Pick<LoginWithRefreshTokenFailure, 'error'>
  ) | (
    { __typename: 'LoginWithRefreshTokenSuccess' }
    & Pick<LoginWithRefreshTokenSuccess, 'uid'>
  ) }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type RecoverEmailMutationVariables = Exact<{
  input: RecoverEmailInput;
}>;


export type RecoverEmailMutation = (
  { __typename?: 'Mutation' }
  & { recoverEmail: (
    { __typename?: 'RecoverEmailFailure' }
    & Pick<RecoverEmailFailure, 'error'>
  ) | (
    { __typename?: 'RecoverEmailSuccess' }
    & Pick<RecoverEmailSuccess, 'uid'>
  ) }
);

export type RegisterAcquisitionUserMutationVariables = Exact<{
  input: RegisterAcquisitionUserInput;
  registrationTrackingData: RegistrationTrackingData;
}>;


export type RegisterAcquisitionUserMutation = (
  { __typename?: 'Mutation' }
  & { registerAcquisitionUser: (
    { __typename?: 'RegisterAcquisitionUserFailure' }
    & Pick<RegisterAcquisitionUserFailure, 'error'>
  ) | (
    { __typename?: 'RegisterAcquisitionUserSuccess' }
    & Pick<RegisterAcquisitionUserSuccess, 'uid'>
  ) }
);

export type RegisterUserMutationVariables = Exact<{
  input: RegisterUserInput;
  registrationTrackingData: RegistrationTrackingData;
}>;


export type RegisterUserMutation = (
  { __typename?: 'Mutation' }
  & { registerUser: (
    { __typename?: 'RegisterUserFailure' }
    & Pick<RegisterUserFailure, 'error'>
  ) | (
    { __typename?: 'RegisterUserSuccess' }
    & Pick<RegisterUserSuccess, 'uid' | 'userCanBeVerified'>
  ) }
);

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword: (
    { __typename?: 'ResetPasswordFailure' }
    & Pick<ResetPasswordFailure, 'error' | 'message'>
  ) | (
    { __typename?: 'ResetPasswordSuccess' }
    & Pick<ResetPasswordSuccess, 'uid'>
  ) }
);

export type SendEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type SendEmailVerificationMutation = (
  { __typename?: 'Mutation' }
  & { sendEmailVerification: (
    { __typename?: 'SendEmailVerificationFailure' }
    & Pick<SendEmailVerificationFailure, 'error'>
  ) | { __typename?: 'SendEmailVerificationSuccess' } }
);

export type SetAcquisitionParamsMutationVariables = Exact<{
  input: SetAcquisitionParamsInput;
}>;


export type SetAcquisitionParamsMutation = (
  { __typename?: 'Mutation' }
  & { setAcquisitionParams: (
    { __typename?: 'SetAcquisitionParamsFailure' }
    & Pick<SetAcquisitionParamsFailure, 'error'>
  ) | (
    { __typename?: 'SetAcquisitionParamsSuccess' }
    & Pick<SetAcquisitionParamsSuccess, 'success'>
  ) }
);

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateUserProfile: (
    { __typename?: 'UpdateUserProfileResult' }
    & Pick<UpdateUserProfileResult, 'uid' | 'verifiedUsmd'>
  ) }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'Me' }
    & { account?: Maybe<(
      { __typename?: 'UserAccount' }
      & Pick<UserAccount, 'uid' | 'email' | 'emailVerified'>
    )>, profile?: Maybe<(
      { __typename?: 'UserProfile' }
      & Pick<UserProfile, 'firstName' | 'lastName' | 'selfReportedUsmd'>
    )>, acquisitionProfile?: Maybe<(
      { __typename?: 'AcquisitionProfile' }
      & Pick<AcquisitionProfile, 'email' | 'firstName' | 'lastName'>
    )> }
  ) }
);

export type SearchMedicalSchoolsQueryVariables = Exact<{
  input: SearchMedicalSchoolsInput;
}>;


export type SearchMedicalSchoolsQuery = (
  { __typename?: 'Query' }
  & { searchMedicalSchools: (
    { __typename?: 'SearchMedicalSchoolsFailure' }
    & Pick<SearchMedicalSchoolsFailure, 'error'>
  ) | (
    { __typename?: 'SearchMedicalSchoolsSuccess' }
    & { medicalSchools: Array<(
      { __typename?: 'MedicalSchool' }
      & Pick<MedicalSchool, 'name'>
    )> }
  ) }
);


export const ChangeEmailDocument = gql`
    mutation ChangeEmail($input: ChangeEmailInput!) {
  changeEmail(input: $input) {
    ... on ChangeEmailSuccess {
      uid
    }
    ... on ChangeEmailFailure {
      error
    }
  }
}
    `;
export type ChangeEmailMutationFn = ApolloReactCommon.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, baseOptions);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = ApolloReactCommon.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const ConfirmEmailVerificationDocument = gql`
    mutation ConfirmEmailVerification($input: ConfirmEmailVerificationInput!) {
  confirmEmailVerification(input: $input) {
    ... on ConfirmEmailVerificationSuccess {
      unit
    }
    ... on ConfirmEmailVerificationFailure {
      error
    }
  }
}
    `;
export type ConfirmEmailVerificationMutationFn = ApolloReactCommon.MutationFunction<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>;

/**
 * __useConfirmEmailVerificationMutation__
 *
 * To run a mutation, you first call `useConfirmEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailVerificationMutation, { data, loading, error }] = useConfirmEmailVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmEmailVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>(ConfirmEmailVerificationDocument, baseOptions);
      }
export type ConfirmEmailVerificationMutationHookResult = ReturnType<typeof useConfirmEmailVerificationMutation>;
export type ConfirmEmailVerificationMutationResult = ApolloReactCommon.MutationResult<ConfirmEmailVerificationMutation>;
export type ConfirmEmailVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmEmailVerificationMutation, ConfirmEmailVerificationMutationVariables>;
export const LoginWithIdTokenDocument = gql`
    mutation LoginWithIdToken($idToken: String!) {
  loginWithIdToken(idToken: $idToken) {
    __typename
    ... on LoginWithIdTokenSuccess {
      uid
    }
    ... on LoginWithIdTokenFailure {
      error
    }
  }
}
    `;
export type LoginWithIdTokenMutationFn = ApolloReactCommon.MutationFunction<LoginWithIdTokenMutation, LoginWithIdTokenMutationVariables>;

/**
 * __useLoginWithIdTokenMutation__
 *
 * To run a mutation, you first call `useLoginWithIdTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithIdTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithIdTokenMutation, { data, loading, error }] = useLoginWithIdTokenMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useLoginWithIdTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithIdTokenMutation, LoginWithIdTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginWithIdTokenMutation, LoginWithIdTokenMutationVariables>(LoginWithIdTokenDocument, baseOptions);
      }
export type LoginWithIdTokenMutationHookResult = ReturnType<typeof useLoginWithIdTokenMutation>;
export type LoginWithIdTokenMutationResult = ApolloReactCommon.MutationResult<LoginWithIdTokenMutation>;
export type LoginWithIdTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginWithIdTokenMutation, LoginWithIdTokenMutationVariables>;
export const LoginWithPasswordDocument = gql`
    mutation LoginWithPassword($input: LoginWithPasswordInput!) {
  loginWithPassword(input: $input) {
    __typename
    ... on LoginWithPasswordSuccess {
      customToken
    }
    ... on LoginWithPasswordFailure {
      error
    }
  }
}
    `;
export type LoginWithPasswordMutationFn = ApolloReactCommon.MutationFunction<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>;

/**
 * __useLoginWithPasswordMutation__
 *
 * To run a mutation, you first call `useLoginWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithPasswordMutation, { data, loading, error }] = useLoginWithPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginWithPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>(LoginWithPasswordDocument, baseOptions);
      }
export type LoginWithPasswordMutationHookResult = ReturnType<typeof useLoginWithPasswordMutation>;
export type LoginWithPasswordMutationResult = ApolloReactCommon.MutationResult<LoginWithPasswordMutation>;
export type LoginWithPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>;
export const LoginWithRefreshTokenDocument = gql`
    mutation LoginWithRefreshToken($refreshToken: String!, $registrationTrackingData: RegistrationTrackingData!) {
  loginWithRefreshToken(refreshToken: $refreshToken, registrationTrackingData: $registrationTrackingData) {
    __typename
    ... on LoginWithRefreshTokenSuccess {
      uid
    }
    ... on LoginWithRefreshTokenFailure {
      error
    }
  }
}
    `;
export type LoginWithRefreshTokenMutationFn = ApolloReactCommon.MutationFunction<LoginWithRefreshTokenMutation, LoginWithRefreshTokenMutationVariables>;

/**
 * __useLoginWithRefreshTokenMutation__
 *
 * To run a mutation, you first call `useLoginWithRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithRefreshTokenMutation, { data, loading, error }] = useLoginWithRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *      registrationTrackingData: // value for 'registrationTrackingData'
 *   },
 * });
 */
export function useLoginWithRefreshTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithRefreshTokenMutation, LoginWithRefreshTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginWithRefreshTokenMutation, LoginWithRefreshTokenMutationVariables>(LoginWithRefreshTokenDocument, baseOptions);
      }
export type LoginWithRefreshTokenMutationHookResult = ReturnType<typeof useLoginWithRefreshTokenMutation>;
export type LoginWithRefreshTokenMutationResult = ApolloReactCommon.MutationResult<LoginWithRefreshTokenMutation>;
export type LoginWithRefreshTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginWithRefreshTokenMutation, LoginWithRefreshTokenMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RecoverEmailDocument = gql`
    mutation RecoverEmail($input: RecoverEmailInput!) {
  recoverEmail(input: $input) {
    ... on RecoverEmailSuccess {
      uid
    }
    ... on RecoverEmailFailure {
      error
    }
  }
}
    `;
export type RecoverEmailMutationFn = ApolloReactCommon.MutationFunction<RecoverEmailMutation, RecoverEmailMutationVariables>;

/**
 * __useRecoverEmailMutation__
 *
 * To run a mutation, you first call `useRecoverEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverEmailMutation, { data, loading, error }] = useRecoverEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecoverEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecoverEmailMutation, RecoverEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<RecoverEmailMutation, RecoverEmailMutationVariables>(RecoverEmailDocument, baseOptions);
      }
export type RecoverEmailMutationHookResult = ReturnType<typeof useRecoverEmailMutation>;
export type RecoverEmailMutationResult = ApolloReactCommon.MutationResult<RecoverEmailMutation>;
export type RecoverEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<RecoverEmailMutation, RecoverEmailMutationVariables>;
export const RegisterAcquisitionUserDocument = gql`
    mutation RegisterAcquisitionUser($input: RegisterAcquisitionUserInput!, $registrationTrackingData: RegistrationTrackingData!) {
  registerAcquisitionUser(input: $input, registrationTrackingData: $registrationTrackingData) {
    ... on RegisterAcquisitionUserSuccess {
      uid
    }
    ... on RegisterAcquisitionUserFailure {
      error
    }
  }
}
    `;
export type RegisterAcquisitionUserMutationFn = ApolloReactCommon.MutationFunction<RegisterAcquisitionUserMutation, RegisterAcquisitionUserMutationVariables>;

/**
 * __useRegisterAcquisitionUserMutation__
 *
 * To run a mutation, you first call `useRegisterAcquisitionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAcquisitionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAcquisitionUserMutation, { data, loading, error }] = useRegisterAcquisitionUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      registrationTrackingData: // value for 'registrationTrackingData'
 *   },
 * });
 */
export function useRegisterAcquisitionUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterAcquisitionUserMutation, RegisterAcquisitionUserMutationVariables>) {
        return ApolloReactHooks.useMutation<RegisterAcquisitionUserMutation, RegisterAcquisitionUserMutationVariables>(RegisterAcquisitionUserDocument, baseOptions);
      }
export type RegisterAcquisitionUserMutationHookResult = ReturnType<typeof useRegisterAcquisitionUserMutation>;
export type RegisterAcquisitionUserMutationResult = ApolloReactCommon.MutationResult<RegisterAcquisitionUserMutation>;
export type RegisterAcquisitionUserMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterAcquisitionUserMutation, RegisterAcquisitionUserMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: RegisterUserInput!, $registrationTrackingData: RegistrationTrackingData!) {
  registerUser(input: $input, registrationTrackingData: $registrationTrackingData) {
    ... on RegisterUserSuccess {
      uid
      userCanBeVerified
    }
    ... on RegisterUserFailure {
      error
    }
  }
}
    `;
export type RegisterUserMutationFn = ApolloReactCommon.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      registrationTrackingData: // value for 'registrationTrackingData'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        return ApolloReactHooks.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, baseOptions);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = ApolloReactCommon.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    ... on ResetPasswordSuccess {
      uid
    }
    ... on ResetPasswordFailure {
      error
      message
    }
  }
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendEmailVerificationDocument = gql`
    mutation SendEmailVerification {
  sendEmailVerification {
    ... on SendEmailVerificationFailure {
      error
    }
  }
}
    `;
export type SendEmailVerificationMutationFn = ApolloReactCommon.MutationFunction<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;

/**
 * __useSendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useSendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailVerificationMutation, { data, loading, error }] = useSendEmailVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendEmailVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument, baseOptions);
      }
export type SendEmailVerificationMutationHookResult = ReturnType<typeof useSendEmailVerificationMutation>;
export type SendEmailVerificationMutationResult = ApolloReactCommon.MutationResult<SendEmailVerificationMutation>;
export type SendEmailVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;
export const SetAcquisitionParamsDocument = gql`
    mutation SetAcquisitionParams($input: SetAcquisitionParamsInput!) {
  setAcquisitionParams(input: $input) {
    ... on SetAcquisitionParamsSuccess {
      success
    }
    ... on SetAcquisitionParamsFailure {
      error
    }
  }
}
    `;
export type SetAcquisitionParamsMutationFn = ApolloReactCommon.MutationFunction<SetAcquisitionParamsMutation, SetAcquisitionParamsMutationVariables>;

/**
 * __useSetAcquisitionParamsMutation__
 *
 * To run a mutation, you first call `useSetAcquisitionParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAcquisitionParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAcquisitionParamsMutation, { data, loading, error }] = useSetAcquisitionParamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAcquisitionParamsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAcquisitionParamsMutation, SetAcquisitionParamsMutationVariables>) {
        return ApolloReactHooks.useMutation<SetAcquisitionParamsMutation, SetAcquisitionParamsMutationVariables>(SetAcquisitionParamsDocument, baseOptions);
      }
export type SetAcquisitionParamsMutationHookResult = ReturnType<typeof useSetAcquisitionParamsMutation>;
export type SetAcquisitionParamsMutationResult = ApolloReactCommon.MutationResult<SetAcquisitionParamsMutation>;
export type SetAcquisitionParamsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetAcquisitionParamsMutation, SetAcquisitionParamsMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    uid
    verifiedUsmd
  }
}
    `;
export type UpdateUserProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, baseOptions);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = ApolloReactCommon.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    account {
      uid
      email
      emailVerified
    }
    profile {
      firstName
      lastName
      selfReportedUsmd
    }
    acquisitionProfile {
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = ApolloReactCommon.QueryResult<MeQuery, MeQueryVariables>;
export const SearchMedicalSchoolsDocument = gql`
    query searchMedicalSchools($input: SearchMedicalSchoolsInput!) {
  searchMedicalSchools(input: $input) {
    ... on SearchMedicalSchoolsSuccess {
      medicalSchools {
        name
      }
    }
    ... on SearchMedicalSchoolsFailure {
      error
    }
  }
}
    `;

/**
 * __useSearchMedicalSchoolsQuery__
 *
 * To run a query within a React component, call `useSearchMedicalSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMedicalSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMedicalSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMedicalSchoolsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchMedicalSchoolsQuery, SearchMedicalSchoolsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchMedicalSchoolsQuery, SearchMedicalSchoolsQueryVariables>(SearchMedicalSchoolsDocument, baseOptions);
      }
export function useSearchMedicalSchoolsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchMedicalSchoolsQuery, SearchMedicalSchoolsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchMedicalSchoolsQuery, SearchMedicalSchoolsQueryVariables>(SearchMedicalSchoolsDocument, baseOptions);
        }
export type SearchMedicalSchoolsQueryHookResult = ReturnType<typeof useSearchMedicalSchoolsQuery>;
export type SearchMedicalSchoolsLazyQueryHookResult = ReturnType<typeof useSearchMedicalSchoolsLazyQuery>;
export type SearchMedicalSchoolsQueryResult = ApolloReactCommon.QueryResult<SearchMedicalSchoolsQuery, SearchMedicalSchoolsQueryVariables>;